<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <sarala-table
                    ref="table"
                    :model="model"
                    :headers="headers"
                    :applyFilter="applyFilter"
                    :exportable="true"
                >
                    <template #reseller="{ item }">
                        {{ item.reseller.trade_name }}
                    </template>

                    <template #paid_at="{ item }">
                        {{ item.formattedPaidAt }}
                    </template>

                    <template #totalValue="{ item }">{{
                        item.formattedTotalValue
                    }}</template>

                    <template #status="{ item }">
                        <v-chip
                            class="ml-3"
                            color="success"
                            text-color="white"
                            v-if="item.paid"
                            small
                        >
                            <v-avatar left>
                                <v-icon small
                                    >mdi-checkbox-marked-circle</v-icon
                                >
                            </v-avatar>
                            Pago
                        </v-chip>
                        <v-chip
                            class="ml-3"
                            color="indigo"
                            text-color="white"
                            v-else-if="item.reviewed"
                            small
                        >
                            <v-avatar left>
                                <v-icon small
                                    >mdi-checkbox-marked-circle</v-icon
                                >
                            </v-avatar>
                            Revisado
                        </v-chip>
                        <v-chip
                            class="ml-3"
                            color="indigo"
                            text-color="white"
                            v-else-if="item.confirmed"
                            small
                        >
                            <v-avatar left>
                                <v-icon small
                                    >mdi-checkbox-marked-circle</v-icon
                                >
                            </v-avatar>
                            Aguardando revisão
                        </v-chip>
                        <v-chip
                            class="ml-3"
                            color="green-blue"
                            text-color="white"
                            v-else-if="item.approved && item.is_current_month"
                            small
                        >
                            <v-avatar left>
                                <v-icon small
                                    >mdi-checkbox-marked-circle</v-icon
                                >
                            </v-avatar>
                            Aguardando nota fiscal
                        </v-chip>
                        <v-chip
                            class="ml-3"
                            color="blue-grey lighten-2"
                            text-color="white"
                            v-else-if="item.is_current_month"
                            small
                        >
                            <v-avatar left>
                                <v-icon small>mdi-clock</v-icon>
                            </v-avatar>
                            Pendente
                        </v-chip>
                        <v-chip
                            color="red lighten-2"
                            text-color="white"
                            v-else
                            class="ml-3"
                            small
                        >
                            <v-avatar left>
                                <v-icon small>mdi-close</v-icon>
                            </v-avatar>
                            Vencida
                        </v-chip>
                    </template>

                    <template #action="{ item }">
                        <v-tooltip bottom v-if="item.invoice">
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    @click="downloadItem(item, 'invoice')"
                                >
                                    <v-icon color="indigo" v-on="on"
                                        >mdi-file-code-outline</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>Nota Fiscal</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="item.payment_voucher">
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    @click="
                                        downloadItem(item, 'payment-voucher')
                                    "
                                >
                                    <v-icon
                                        color="light-green darken-2"
                                        v-on="on"
                                        >mdi-file-document-box-check-outline</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>Comprovante de Pagamento</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    @click="showItem(item)"
                                >
                                    <v-icon
                                        color="light-grey darken-2"
                                        v-on="on"
                                        >mdi-text-box-search</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('form.actions.show') }}</span>
                        </v-tooltip>
                    </template>
                </sarala-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import SaralaTable from '@/shared/components/SaralaTable'
import Commission from '@/models/Commission'

export default {
    components: {
        'sarala-table': SaralaTable,
    },

    data() {
        return {
            tabActive: 'onlyNotPaid',
        }
    },

    computed: {
        model() {
            return new Commission()
        },

        headers() {
            return [
                {
                    text: 'Parceiro',
                    value: 'reseller',
                },
                {
                    text: 'Mês',
                    value: 'month',
                },
                {
                    text: 'Ano',
                    value: 'year',
                },
                {
                    text: 'Valor',
                    value: 'totalValue',
                },
                {
                    text: 'Status',
                    value: 'status',
                    hide: this.tabActive == 'onlyPaid',
                },
                {
                    text: 'Pago',
                    value: 'paid_at',
                    hide: this.tabActive == 'onlyNotPaid',
                },
                {
                    text: 'Ações',
                    value: 'action',
                    sortable: false,
                    width: 150,
                    align: 'end',
                },
            ]
        },
    },

    methods: {
        showItem(item) {
            this.$router.push({
                name: 'commissions/show',
                params: { id: item.id },
            })
        },

        async downloadItem(item, type) {
            let res = await this.$http.get(`commissions/${item.id}/${type}`, {
                responseType: 'blob',
            })

            if (!res) return

            let name = type == 'invoice' ? item.invoice : item.payment_voucher

            const url = window.URL.createObjectURL(res.data)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', name)
            document.body.appendChild(link)
            link.click()
        },

        applyFilter(model) {
            model.where(this.tabActive, true)
        },

        changeTab() {
            this.$refs.table.getItems()
        },
    },
}
</script>
